/**
 * Punto de entrada del curriculum.
 *
 * La interfaz consume SIEMPRE `CURRICULUM_ACTUAL`. Ninguna pantalla importa
 * una versión concreta: así cambiar de versión no obliga a tocar la UI.
 */

import { CURRICULUM_V1, VERSION_CURRICULUM } from './v1/index.js';

export const CURRICULUM_ACTUAL = CURRICULUM_V1;
export const VERSION_CURRICULUM_ACTUAL = VERSION_CURRICULUM;

export * from './tipos.js';
export { construirPrompt, AREA_EN_INGLES } from './v1/prompts.js';
export { bloqueDeSemana, BLOQUES_ENFASIS } from './v1/enfasis.js';
export { HERRAMIENTAS, HERRAMIENTA_POR_CLAVE } from './v1/herramientas.js';
export {
  FUENTES_LISTENING,
  FUENTE_LISTENING_POR_CLAVE,
  FALLBACK_SIN_FUENTE,
} from './v1/fuentesListening.js';
export { QUE_ES_UNA_DIFICULTAD_PRINCIPAL } from './v1/sesiones/baseline.js';
